import { Box, BoxProps, FilledArrowIcon } from '@modusign/design-system';

interface RoundButtonProps extends BoxProps<'button'> {
  showIcon?: boolean;
}

export default function RoundButton({ children, showIcon, ...props }: RoundButtonProps) {
  return (
    <Box
      as="button"
      border="1px solid"
      borderColor="buttonBorderNeutralLightest"
      borderRadius="17px"
      color="textNeutralLightest"
      fontSize="sm"
      fontWeight="medium"
      minHeight="34px"
      px={5}
      py={2}
      sx={{
        ':hover:enabled, :focus': {
          borderColor: 'white',
          color: 'textNeutralBase',
          bg: 'white',
        },
        ':disabled': {
          borderColor: 'buttonBorderSecondaryDark',
          color: 'textNeutralLight',
        },
      }}
      textAlign={showIcon ? 'left' : 'center'}
      {...props}
    >
      {children}
      {showIcon && (
        <FilledArrowIcon
          direction="down"
          sx={{
            position: 'absolute',
            right: '10px',
            top: '15px',
          }}
        />
      )}
    </Box>
  );
}
